import React from 'react';

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 10.5C3.75 6.77196 6.77196 3.75 10.5 3.75C14.2273 3.75 17.25 6.77201 17.25 10.5C17.25 14.2273 14.2273 17.25 10.5 17.25C6.77201 17.25 3.75 14.2273 3.75 10.5ZM10.5 2.25C5.94354 2.25 2.25 5.94354 2.25 10.5C2.25 15.0557 5.94349 18.75 10.5 18.75C12.508 18.75 14.3487 18.0323 15.7795 16.8394L20.4699 21.5299L21.5306 20.4692L16.8401 15.7787C18.0325 14.348 18.75 12.5077 18.75 10.5C18.75 5.94349 15.0557 2.25 10.5 2.25Z"
      fill="black"
    />
  </svg>
);
